<div class="common-back-btn-blue" (click)="goLearningMap()"></div>
<div class="tools-wrap">
  <img src="{{assetsRoute}}/picture/tools/tools-1.jpg" alt="" />
  <img src="{{assetsRoute}}/picture/tools/tools-2.jpg" alt="" />

  <div class="tools-tips">
    你可以用电脑浏览器打开网址进行试用：<br>
    <span>https://m.transtalent.cn/pc/</span>
  </div>

  <img src="../../assets/picture/tools/tools-guide-bottom.png" alt="" />
</div>



// WEBPACK FOOTER //
// ./src/app/app-tools/app-tools.component.html